import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface ICargoTypeCargoCharacteristicAttributes extends IModelAttributes {
	cargoTypeId: string;
	cargoCharacteristicId: string;

	cargoType: Models.CargoTypeEntity | Models.ICargoTypeEntityAttributes;
	cargoCharacteristic: Models.CargoCharacteristicEntity | Models.ICargoCharacteristicEntityAttributes;
}

@entity('CargoTypeCargoCharacteristic')
export default class CargoTypeCargoCharacteristic extends Model implements ICargoTypeCargoCharacteristicAttributes {
	@observable
	@attribute()
	public cargoCharacteristicId: string;

	@observable
	@attribute()
	public cargoTypeId: string;

	@observable
	@attribute({ isReference: true })
	public cargoType: Models.CargoTypeEntity;

	@observable
	@attribute({ isReference: true })
	public cargoCharacteristic: Models.CargoCharacteristicEntity;

	constructor(attributes?: Partial<ICargoTypeCargoCharacteristicAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.cargoTypeId) {
				this.cargoTypeId = attributes.cargoTypeId;
			}
			if (attributes.cargoCharacteristicId) {
				this.cargoCharacteristicId = attributes.cargoCharacteristicId;
			}

			if (attributes.cargoType) {
				if (attributes.cargoType instanceof Models.CargoTypeEntity) {
					this.cargoType = attributes.cargoType;
					this.cargoTypeId = attributes.cargoType.id;
				} else {
					this.cargoType = new Models.CargoTypeEntity(attributes.cargoType);
					this.cargoTypeId = this.cargoType.id;
				}
			} else if (attributes.cargoTypeId !== undefined) {
				this.cargoTypeId = attributes.cargoTypeId;
			}

			if (attributes.cargoCharacteristic) {
				if (attributes.cargoCharacteristic instanceof Models.CargoCharacteristicEntity) {
					this.cargoCharacteristic = attributes.cargoCharacteristic;
					this.cargoCharacteristicId = attributes.cargoCharacteristic.id;
				} else {
					this.cargoCharacteristic = new Models.CargoCharacteristicEntity(attributes.cargoCharacteristic);
					this.cargoCharacteristicId = this.cargoCharacteristic.id;
				}
			} else if (attributes.cargoCharacteristicId !== undefined) {
				this.cargoCharacteristicId = attributes.cargoCharacteristicId;
			}
		}
	}
}
